import Component from "@ember/component";
import { classNames } from "@ember-decorators/component";

@classNames("admin-below-plugins-index-outlet", "discoursehosting")
export default <template>
  <div style="padding: 12px; background-color: #fffbd6; color: #222;">
    In order to install plugins on Communiteq Discourse Hosting, please go to our
    control panel at
    <a target="_blank" href="https://controlpanel.communiteq.com/cp/">https://controlpanel.communiteq.com/cp/</a>
    and select Plugins from the left hand menu.
  </div>
</template>